import { CatalogSearchQuery } from "modules/PsyCatalog/common/searchQuery"

export class Cities {
    private static readonly list = new Map<string, CatalogSearchQuery["city"]>([
        ["msk", "Москва"],
        ["spb", "Санкт-Петербург"],
    ])

    static getShortcut(city?: string) {
        if (!city) return
        return Array.from(Cities.list.entries()).find((entry) => entry[1] === city)?.[0]
    }
}
